import { ref } from 'vue'

import type { Ref } from 'vue'

/**
 * Types
 */
type UseModal = () => {
  isOpened: Ref<boolean>
  open: () => void
  close: () => void
}

/**
 * Composable
 */
export const useModal: UseModal = () => {
  const isOpened = ref(false)

  return {
    isOpened,
    open: () => {
      isOpened.value = true
    },
    close: () => {
      isOpened.value = false
    },
  }
}
